import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SelfServiceModal',
  props: {
    modalOpen: { type: Boolean }
  },
  emits: ['closeModal'],
  setup(__props: any, { emit }) {






function closeModal() {
    emit('closeModal');
}

return { __sfc: true,emit, closeModal }
}

})